import { render } from "./TemplateMfittBooking4.vue?vue&type=template&id=74441271&scoped=true"
import script from "./TemplateMfittBooking4.vue?vue&type=script&lang=js"
export * from "./TemplateMfittBooking4.vue?vue&type=script&lang=js"

import "./TemplateMfittBooking4.vue?vue&type=style&index=0&id=74441271&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-74441271"

export default script